import React from 'react';
import PropTypes from 'prop-types';

import styles from './TabMenu.module.scss';

const TabMenu = ({ text, onclick, isActive }) => {
    return (
        <div className={!isActive ? styles.TabMenu : styles.TabMenu + ' ' + styles.TabMenu__activate} onClick={onclick}>
            <div className={styles.TabMenu__text}>{text}</div>
        </div>
    );
};

TabMenu.propTypes = {
    text: PropTypes.string,
    onclick: PropTypes.func,
    isActive: PropTypes.bool
};

export default TabMenu;
